module.exports = __webpack_public_path__ + "img/2LNG_Cover.586157b9.jpg";